import { Pipe, PipeTransform } from '@angular/core';
import { Permissions } from '../permission-def';

@Pipe({
  name: 'validPermissions'
})
export class ValidPermissionsPipe implements PipeTransform {

  transform(value: Permissions | Permissions[]): any {
    return value;
  }

}
